import BaseViewController from "./base-view-controller";
import { consentMessageBuilder } from "../utils/consent-message-builder";
import { CONSENT_VALIDATION_MESSAGES } from "../utils/constants";

class VisitMhMinorConsentViewController extends BaseViewController {
  preprocessScreenData() {
    this.screen.fields = this.screen.fields.map(field =>
      field.name.includes("upload_after_instructions") &&
      typeof field.title === "string"
        ? {
            ...field,
            isFirstLineTheHeader: true,
            title: field.title.replace(": ", ":\n").split("\n")
          }
        : field
    );
    if (
      (this.appData.values["__photo1:attachment_type_cd"] ===
        "BEHAVHEALTH_CONSENTFORM" &&
        this.appData.values["__photo1:photoPreview"] &&
        !this.appData.values["__photo2:attachment_type_cd"]) ||
      (this.appData.values["__photo2:attachment_type_cd"] ===
        "BEHAVHEALTH_CONSENTFORM" &&
        this.appData.values["__photo2:photoPreview"] &&
        !this.appData.values["__photo1:attachment_type_cd"])
    ) {
      this.screen.fields = consentMessageBuilder(
        this.screen.fields,
        CONSENT_VALIDATION_MESSAGES.missingIntake
      );
    } else if (
      (this.appData.values["__photo1:attachment_type_cd"] ===
        "BEHAVHEALTH_INTAKEFORM" &&
        this.appData.values["__photo1:photoPreview"] &&
        !this.appData.values["__photo2:attachment_type_cd"]) ||
      (this.appData.values["__photo2:attachment_type_cd"] ===
        "BEHAVHEALTH_INTAKEFORM" &&
        this.appData.values["__photo2:photoPreview"] &&
        !this.appData.values["__photo1:attachment_type_cd"])
    ) {
      this.screen.fields = consentMessageBuilder(
        this.screen.fields,
        CONSENT_VALIDATION_MESSAGES.missingConsent
      );
    } else if (
      this.appData.values["__photo1:photoPreview"] &&
      this.appData.values["__photo2:photoPreview"]
    ) {
      this.screen.fields = consentMessageBuilder(this.screen.fields);
    } else {
      this.screen.fields = consentMessageBuilder(
        this.screen.fields,
        CONSENT_VALIDATION_MESSAGES.generalMessage
      );
    }
  }
}
export default VisitMhMinorConsentViewController;
